import { getToken } from '@bd/api/common/auth'
import { AuthState } from '../../types'

export const state: AuthState = {
  accessToken: getToken() || '',
  user: undefined,
  error: undefined,
}
